"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionsQuery = void 0;
// Based on the generated query
exports.permissionsQuery = `
permissions {
  isPending
  invitationId
  userId
  action
  createdBy
  createdAt
  inviteeEmail
}
`;
